var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgYouTube = function SvgYouTube(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 14.68s-.25-2.21-1.25-3.13c-1.12-1.3-2.37-1.3-3-1.3C27.25 10 21 10 21 10s-6.25 0-10.5.26c-.63.14-1.88.14-3 1.3-.87.9-1.25 3.12-1.25 3.12S6 17.13 6 19.74v2.34c0 2.46.25 5.06.25 5.06s.25 2.21 1.25 3.12c1.13 1.3 2.63 1.16 3.25 1.3 2.37.26 10.25.26 10.25.26s6.25 0 10.5-.4c.63-.13 1.88-.13 3-1.3.87-.9 1.25-3.1 1.25-3.1s.25-2.47.25-5.07V19.6c0-2.46-.25-4.93-.25-4.93ZM17.86 24.93v-8.7L26 20.65l-8.13 4.28Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYouTube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youTube.704eb3fcab75c390958e1d197ed4d25e.svg";